const isDevelopment = process.env.NODE_ENV === 'development';

export const API_CONFIG = {
  MAIN: isDevelopment
    ? `${process.env.REACT_APP_SERVER_IP}:3601`
    : '/api'
};
